/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer" | "SbSharedThinBrowseItemTrackingProvider_viewer">;
    readonly " $refType": "SbSharedRecentlySoldItems_viewer";
};
export type SbSharedRecentlySoldItems_viewer$data = SbSharedRecentlySoldItems_viewer;
export type SbSharedRecentlySoldItems_viewer$key = {
    readonly " $data"?: SbSharedRecentlySoldItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRecentlySoldItems_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_viewer",
  "selections": [
    {
      "alias": "isSeoQuicklookEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'f56deae0ac1c6491d11c866bbcfc200d';
export default node;
